import { sortLinkedItems } from "utils/utils";
import { TEntityDateblock } from "../models";

export type TBidPackageLinkedMaterial = {
  id: string;
  number?: string;
  title?: string;
  auto_inc_value?: string | number;
  feature_type_id?: number;
  implicit?: boolean;
  governing_link?: boolean;
  feature_workflow_instance?: {
    workflow_status?: string;
    milestone_state?: string;
    risk_level?: string | null;
  };
  workflow_instance_milestones?: Array<{
    id?: string;
    name?: string;
    sequence_no?: number;
    planned_date?: string | null;
    actual_date?: string | null;
  }>;
  feature_instance_spec_sections?: Array<{
    spec_section?: {
      section_number?: string;
      section_name?: string;
      title?: string;
    };
  }>;
};

// The same item can come back on more than one link row; show it once and
// keep it governing if any of its links is governing.
export function dedupeLinkedItemsById<
  T extends { id: string; governing_link?: boolean }
>(items: T[]): T[] {
  const byId = new Map<string, T>();
  items.forEach((item) => {
    const existing = byId.get(item.id);
    byId.set(
      item.id,
      existing
        ? {
            ...item,
            ...existing,
            governing_link: Boolean(
              existing.governing_link || item.governing_link
            )
          }
        : item
    );
  });
  return Array.from(byId.values());
}

/** Materials listed on the Bid Package Material tab, from `bid_package_materials`. */
export function getBidPackageLinkedMaterials(
  entity?: TEntityDateblock
): TBidPackageLinkedMaterial[] {
  const planningLinks = (entity as any)?.bid_package_materials as
    | Array<{
        target_feature_instance?: {
          links_as_source?: Array<{
            governing_link?: boolean;
            target_feature_instance?: TBidPackageLinkedMaterial;
          }>;
        };
      }>
    | undefined;

  const materials = (planningLinks ?? [])
    .flatMap((link) => link.target_feature_instance?.links_as_source ?? [])
    .filter((link) => link.target_feature_instance?.id)
    .map((link) => ({
      ...(link.target_feature_instance as TBidPackageLinkedMaterial),
      governing_link: link.governing_link
    }));

  return sortLinkedItems(
    dedupeLinkedItemsById(materials),
    "auto_inc_value"
  ) as TBidPackageLinkedMaterial[];
}
